import env from "../../utils/env";

let JobRequestsService = function (HttpService) {
  "ngInject";

  const getDataSource = (successCb) => {
    const dataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: env.getApiUrl("jobrequests/search"),
          contentType: "application/json",
          type: "POST",
          beforeSend: _onBeforeSend,
        },
        update: {
          url: _getResourceLocation,
          contentType: "application/json",
          type: "PATCH",
          beforeSend: _onBeforeSend,
        },
        parameterMap: _parameterMap
      },
      change: successCb,
      schema: {
        data: "data",
        total: "total",
        model: {
          id: "id",
          fields: {
            "creationDate": { type: "date", editable: false, validation: { required: true } },
            "notes": { nullable: false, validation: { required: false } },
            "id": {},
          }
        }
      },
      serverFiltering: true,
      serverPaging: true,
      serverSorting: true,
      pageSize: 50
    })

    return dataSource;
  }

  const transferJob = (jobRequest, successCb, failureCb) => {
    HttpService.patch(`jobrequests/${jobRequest.id}/transfer-job`, jobRequest, successCb, failureCb);
  }

  return { getDataSource, transferJob };
}

function _getResourceLocation(options) {
  return env.getApiUrl(`jobrequests/${options.id}`);
}

function _onBeforeSend(req) {
  var token = `Bearer ${window.localStorage.getItem("bigfootAccessToken")}`;

  req.setRequestHeader("Authorization", token);
}

function _parameterMap(data, type) {
  if(type == "read") {
    let filters = [];

    if (data.filter) filters = data.filter.filters;

    let query = Object.assign({}, { filters: filters }, data)
    delete query.filter;

    console.log("Query::", query)

    return JSON.stringify(query);
  }

  if(type == "update") {
    return JSON.stringify(data);
  }
}

export default JobRequestsService;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/services/job-requests.service.js
 **/